/// <amd-module name="Artifacts/Root/redux/Module" />

import { IRootModuleState } from "Artifacts/Root/redux/Contracts";
import { rootReducer } from "Artifacts/Root/redux/Reducer";
import rootSaga from "Artifacts/Root/redux/Sagas";
import { ISagaModule } from "redux-dynamic-modules-saga";

const _rootModule: ISagaModule<IRootModuleState> = {
  id: "root",
  reducerMap: {
    rootState: rootReducer,
  },
  sagas: [rootSaga],
};

export const RootModule = _rootModule;
